export default "assets/images/square-c95e3b60.svg";